// TODO: After everyone makes use of the correct version of the layout, this can be removed
export default ({ route, store }) => {
  try {
    const meta = route.meta || [];
    const { useLayoutV2 } = meta.find(item => item.useLayoutV2) || {};

    if (typeof useLayoutV2 === 'boolean') {
      store.commit('_core/application/PREPARE_LAYOUT_V2', useLayoutV2);
    } else {
      store.commit('_core/application/PREPARE_LAYOUT_V2', false);
    }
  } catch (err) {
    // Prevent unexcpected behavior
  }
};
